import { HostAppName } from "../office-js/HostAppSettings";
import { HostAppUtil } from "../office-js/HostAppUtil";
import oneNoteTranscriptionManager from "../OneNote/OneNoteTranscriptionManager";
import { IAddTranscriptionIndicatorToHost } from "../interfaces/IAddTranscriptionIndicatorToHost";

/* Here we are initializing the AddTranscriptionIndicatorToHost provider on basis of user's host app
 depending upon whether it is Word or OneNote or any other office app, by default we will set the provider for oneNote.
 This provider will initialize the appropriate class on basis of host app name which
 will have app specific api implementations for doing Add Host App indicator functionality.*/
export const CreateAddTranscriptionIndicatorProvider = () : IAddTranscriptionIndicatorToHost => {
    const hostAppName = HostAppUtil.GetHostAppName();
    switch (hostAppName) {
        case HostAppName.ONENOTE:
            return oneNoteTranscriptionManager;
        default:
            throw Error("Transcription Indicator not supported for " + hostAppName);
    }
}